<template>
    <v-container>
      <h1>{{ $t('politicaDePrivacidadePartiuApp.title') }}</h1>
      <p><strong>{{ $t('politicaDePrivacidadePartiuApp.lastUpdate') }}</strong> {{ $t('politicaDePrivacidadePartiuApp.lastUpdateDate') }}</p>
      <p>
        {{ $t('politicaDePrivacidadePartiuApp.introduction') }}
      </p>
      <h2>{{ $t('politicaDePrivacidadePartiuApp.sections.dataController.title') }}</h2>
      <p>
        {{ $t('politicaDePrivacidadePartiuApp.sections.dataController.content') }}
      </p>
      <h2>{{ $t('politicaDePrivacidadePartiuApp.sections.collectedData.title') }}</h2>
      <ul>
        <li v-for="(item, index) in $t('politicaDePrivacidadePartiuApp.sections.collectedData.items')" :key="index">{{ item }}</li>
      </ul>
      <h2>{{ $t('politicaDePrivacidadePartiuApp.sections.dataCollection.title') }}</h2>
      <ul>
        <li v-for="(item, index) in $t('politicaDePrivacidadePartiuApp.sections.dataCollection.items')" :key="index">{{ item }}</li>
      </ul>
      <h2>{{ $t('politicaDePrivacidadePartiuApp.sections.dataPurposes.title') }}</h2>
      <ul>
        <li v-for="(item, index) in $t('politicaDePrivacidadePartiuApp.sections.dataPurposes.items')" :key="index">{{ item }}</li>
      </ul>
      <h2>{{ $t('politicaDePrivacidadePartiuApp.sections.dataSharing.title') }}</h2>
      <p>
        {{ $t('politicaDePrivacidadePartiuApp.sections.dataSharing.content') }}
      </p>
      <h2>{{ $t('politicaDePrivacidadePartiuApp.sections.dataStorage.title') }}</h2>
      <p>
        {{ $t('politicaDePrivacidadePartiuApp.sections.dataStorage.content') }}
      </p>
      <ul>
        <li v-for="(item, index) in $t('politicaDePrivacidadePartiuApp.sections.dataStorage.securityMeasures')" :key="index">{{ item }}</li>
      </ul>
      <p>
        {{ $t('politicaDePrivacidadePartiuApp.sections.dataStorage.additionalInfo') }}
      </p>
      <h2>{{ $t('politicaDePrivacidadePartiuApp.sections.cookies.title') }}</h2>
      <p>
        {{ $t('politicaDePrivacidadePartiuApp.sections.cookies.content') }}
      </p>
      <h2>{{ $t('politicaDePrivacidadePartiuApp.sections.analytics.title') }}</h2>
      <p>
        {{ $t('politicaDePrivacidadePartiuApp.sections.analytics.content') }}
      </p>
      <h2>{{ $t('politicaDePrivacidadePartiuApp.sections.directMarketing.title') }}</h2>
      <p>
        {{ $t('politicaDePrivacidadePartiuApp.sections.directMarketing.content') }}
      </p>
      <h2>{{ $t('politicaDePrivacidadePartiuApp.sections.finalProvisions.title') }}</h2>
      <p>
        {{ $t('politicaDePrivacidadePartiuApp.sections.finalProvisions.content') }}
      </p>
      <p>
        {{ $t('politicaDePrivacidadePartiuApp.sections.finalProvisions.contact') }}
      </p>
    </v-container>
  </template>
  
  <script>
  export default {
    data(){},
    methods: {},
  };
  </script>